module.exports = __webpack_public_path__ + "static/media/logo_gpbank.9cc4acff.svg";